var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.checkoutConditions
    ? _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
        _c("div", { staticClass: "card-body" }, [
          _vm.checkoutConditions &&
          _vm.checkoutConditions.allow_photo_attachment
            ? _c(
                "div",
                { staticClass: "pb-3" },
                [
                  _c("label", { attrs: { for: "remark" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.checkoutConditions.required_photo_attachment
                            ? _vm.$t(
                                "message.booking.checkout_step.attach_photos"
                              )
                            : _vm.$t(
                                "message.booking.checkout_step.attach_photos_not_required"
                              )
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-remark mb-2" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$i18n.locale === "th"
                            ? _vm.checkoutConditions.photo_attachment_remark_th
                            : _vm.checkoutConditions.photo_attachment_remark_en
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("vue-dropzone", {
                    ref: "vueDropzone",
                    staticClass: "dropzone-dashed",
                    attrs: {
                      id: "dropzone",
                      destroyDropzone: false,
                      options: _vm.dropzoneOptions
                    },
                    on: {
                      "vdropzone-sending": _vm.vueDropZoneAddParams,
                      "vdropzone-removed-file": _vm.vueDropZoneRemovedFile,
                      "vdropzone-mounted": _vm.vueDropZoneMounted,
                      "vdropzone-success": _vm.vueDropZoneSuccess
                    }
                  }),
                  _vm._v(" "),
                  _vm.hasError
                    ? _c(
                        "div",
                        { staticClass: "mt-2 text-remark -status-alert" },
                        [
                          _c("i", {
                            staticClass: "fas fa-exclamation-triangle"
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("message.required_photo_attachment")
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "remark" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("message.service_request.big_cleaning_remark")
                  ) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.remark,
                  expression: "remark"
                }
              ],
              ref: "remark",
              staticClass: "form-control textarea-jumbo",
              attrs: {
                rows: "3",
                id: "remark",
                placeholder: _vm.$t(
                  "message.service_request.deep_cleaning_remark"
                )
              },
              domProps: { value: _vm.remark },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.remark = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.checkoutConditions.service_remark_title_th
            ? _c("div", { staticClass: "text-small text-orange pb-2" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$i18n.locale === "th"
                        ? _vm.checkoutConditions.service_remark_title_th
                        : _vm.checkoutConditions.service_remark_title_en
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.checkoutConditions.service_remark_detail_th
            ? _c("div", {
                staticClass: "text-remark",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$i18n.locale === "th"
                      ? _vm.checkoutConditions.service_remark_detail_th
                      : _vm.checkoutConditions.service_remark_detail_th
                  )
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "pt-3" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-block",
                on: {
                  click: function($event) {
                    return _vm.submit()
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.button.submit")) +
                    "\n      "
                )
              ]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68d9cde5", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68d9cde5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/AdditionalRemarkMessage.vue
// module id = 2211
// module chunks = 0